import './Subiecte.css';

export default function TesteAntrenament2021() {
    const teste = Array.from({ length: 12 }, (_, i) => i + 1);

    return (
        <div className="container my-4">
            <h2 className="fw-bold mb-4 subjectTitle">Teste Antrenament 2021</h2>
            {teste.map((num) => (
                <div key={num} className="mb-4">
                    <h5>{num}. <strong>Testul {num}</strong></h5>
                    <ul className="ms-3">
                        <li>
                            <strong>Specializarea Matematică-Informatică:</strong>
                            <ul className="ms-3">
                                <li>
                                    <a href={`/subiecte/2021/SubiectTestAntrenament${num}-2021MIC.pdf`} target="_blank" rel="noreferrer">Subiect C/C++</a> |{' '}
                                    <a href={`/subiecte/2021/SubiectTestAntrenament${num}-2021MIPascal.pdf`} target="_blank" rel="noreferrer">Subiect Pascal</a>
                                </li>
                                <li>
                                    <a href={`/subiecte/2021/BaremTestAntrenament${num}-2021MI.pdf`} target="_blank" rel="noreferrer">Barem</a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <strong>Specializarea Științele-Naturii:</strong>
                            <ul className="ms-3">
                                <li>
                                    <a href={`/subiecte/2021/SubiectTestAntrenament${num}-2021SNC.pdf`} target="_blank" rel="noreferrer">Subiect C/C++</a> |{' '}
                                    <a href={`/subiecte/2021/SubiectTestAntrenament${num}-2021SNPascal.pdf`} target="_blank" rel="noreferrer">Subiect Pascal</a>
                                </li>
                                <li>
                                    <a href={`/subiecte/2021/BaremTestAntrenament${num}-2021SN.pdf`} target="_blank" rel="noreferrer">Barem</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            ))}
        </div>
    );
}